export enum BefundArt {
  SONOGRAPHIE = 'SONOGRAPHIE',
  ROENTGEN = 'ROENTGEN',
  CT = 'CT',
  MRT = 'MRT',
  LABOR = 'LABOR',
  KOERPERLICHE_UNTERSUCHUNG = 'KOERPERLICHE_UNTERSUCHUNG',
  ANDERE = 'ANDERE',
}

export const befundArtOptions: { label: string; value: BefundArt }[] = [
  { label: 'Sonographie', value: BefundArt.SONOGRAPHIE },
  { label: 'Röntgen', value: BefundArt.ROENTGEN },
  { label: 'CT', value: BefundArt.CT },
  { label: 'MRT', value: BefundArt.MRT },
  { label: 'Labor', value: BefundArt.LABOR },
  { label: 'Körperliche Untersuchung', value: BefundArt.KOERPERLICHE_UNTERSUCHUNG },
  { label: 'Andere', value: BefundArt.ANDERE },
];
